module.exports = __webpack_public_path__ + "static/media/20210403_205733_106_IMG_0013.8375d168.jpg";